<template>
  <v-card style=" margin: 0 auto;border-radius:16px;">
    <v-container >
      <v-flex xs12 v-if="isOwner" style="text-align:right">
        <v-btn @click="$router.push({name: 'editShop', params: {shop: shop}})" outline small color="primary">編集</v-btn>
      </v-flex>
      <!-- 基本情報 -->
      <v-flex xs12 style="text-align:left;margin-bottom:16px">
        <p style="margin-bottom:5px;">{{areaText}}</p>
        <h1 class="headline" style="font-weight: bold;margin-bottom:5px">{{shop.basic.name}}</h1>
        <p><v-chip v-if="shop.basic.genre" small label dark color="primary">{{shop.basic.genre}}</v-chip></p>
      </v-flex>
      <!-- ／基本情報 -->
      <!-- トップ画像 -->
      <v-flex v-if="place.photos.length>0" xs12 style="text-align:center;margin-bottom:16px;">
        <img :src="$options.filters.placePhoto(place.photos[0].photo_reference)" style="max-width:300px;max-height:300px;">
        <img :src="$options.filters.placePhoto(place.photos[1].photo_reference)" style="max-width:300px;max-height:300px;">
      </v-flex>
      <v-flex v-if="shop.basic.imageurl !== ''" xs12 style="text-align:center;margin-bottom:16px;">
        <img :src="shop.basic.imageurl" style="max-width:300px;max-height:300px;">
      </v-flex>
      <!-- ／トップ画像 -->
      <!-- 件数表示用チップ -->
      <v-layout row wrap style="margin: 16px 0;">
        <v-flex xs12 style="text-align:left;">
          <template v-if="tabetaiCount>0" class="primary--text">
            <v-chip small color="primary" dark label><v-icon>favorite_outline</v-icon>{{tabetaiCount}}件</v-chip>
          </template>
          <template v-if="postCount>0" class="primary--text">
            <v-chip @click="scroll2Review" small color="primary" outline label>カラログ：{{postCount}}件</v-chip>
          </template>
          <template v-if="snsCount>0" class="primary--text">
            <v-chip @click="scroll2Sns" small color="primary" outline label>SNS：{{snsCount}}件</v-chip>
          </template>
        </v-flex>
      </v-layout>
      <!-- ／件数表示用チップ -->
      <!-- レビュー一覧 -->
      <v-layout row wrap style="margin: 10px 0;">
        <h2 class="title komidashi" id="reviewTop">みんなのカラログ</h2>
        <v-flex xs12 v-if="posts.length>0">
          <review-card
          @onReviewCardClick="onReviewCardClick"
          :post=p v-for="(p, id) in posts" :key=id
          style="margin-bottom:16px;">
          </review-card>
        </v-flex>
        <v-flex xs12 v-else style="padding:10px;">
          <p>まだカラログは投稿されてません。</p>
          <v-btn @click="onReview" color="primary" outline block><v-icon>add</v-icon>&nbsp;カラログを投稿する</v-btn>
        </v-flex>
      </v-layout>
      <!-- ／レビュー一覧 -->
      <v-layout row wrap>
        <h2 class="title komidashi" id="snsTop">店舗情報</h2>
        <v-flex xs12 style="text-align:left;">
          <p v-html="name"></p>
          <p><v-icon small>store_mall_directory</v-icon><span v-html="address"></span></p>
          <p v-if="phone!==''"><v-icon small>phone</v-icon>{{phone}}</p>
          <p style="margin-top:4px;">営業時間</p>
          <ul style="padding-left:5px;">
            <li style="list-style:none;font-size:80%;" v-for="(w, id) in open" :key=id>
              {{w}}
            </li>
          </ul>
          <p v-if="url!==''">
            <a :href="url" target="_blank">店舗のホームページはこちら</a>
          </p>
        </v-flex>
      </v-layout>
      <!-- GoogleMap -->
      <v-flex xs12 style="min-height:300px;margin-top:16px;">
        <iframe width="100%" height="300px;" style="border:0" :src="`https://maps.google.co.jp/maps?&output=embed&q=${lat},${lng} ${shop.basic.name}`"></iframe>
      </v-flex>
      <!-- ／GoogleMap -->
      <!-- Googleレビュー --> 
      <v-layout v-if="powerdBy==='Google'" row wrap style="margin-top:16px;">
        <h2 class="title komidashi" id="snsTop">店舗のレビュー、口コミ</h2>
        <v-flex xs12 v-for="(r, id) in place.reviews" :key=id
          style="border: solid 1px #eee;text-align:left;margin-bottom:16px;padding:5px;"
        >
          <p style="padding-bottom:5px;">
            <v-avatar size="30"><v-img :src="r.profile_photo_url" :lazy-src="require('@/assets/img/person_icon.png')"></v-img></v-avatar>
            <span style="padding-left:5px;padding-top:3px;">{{r.author_name | textTrim(30)}}</span>
          </p>
          <p>{{r.text}}</p>
          <p><v-chip small outline color="orange">★ {{r.rating}}.0</v-chip></p>
        </v-flex>
      </v-layout>
      <!-- Googleレビュー -->
      <!-- SNSの反応・感想一覧-->
      <v-layout v-if="isSnsUrl" row wrap>
        <h2 class="title komidashi" id="snsTop">SNSの反応・評価</h2>
        <v-flex xs12>
          <sns-card
          :url=url v-for="(url, id) in shop.snsUrls" :key=id
          style="margin-bottom:16px;">
          </sns-card>
        </v-flex>
      </v-layout>
      <!-- /SNSの反応・感想一覧-->
      <!-- 情報提供者-->
      <v-layout v-if="isProvider_gekikara" row wrap>
        <h2 class="title komidashi" style="margin-top:16px;">情報提供</h2>
        <v-flex xs12 style="border: 1px solid #ddd; padding:16px; border-radius:10px;">
          <p><a :href="shop.provider.url" target="_blank">{{shop.provider.name}}</a> 様</p>
          <p v-html="zakara" style="margin-bottom:0;"></p>
        </v-flex>
      </v-layout>
      <v-layout v-if="isProvider_karaiine_user" row wrap>
        <h2 class="title komidashi" style="margin-top:16px;">情報提供</h2>
        <v-flex 
         @click="$router.push({name: 'UserTop', params: {id: shop.provider.user.uid}})"
         xs12 style="border: 1px solid #ddd; padding:16px; border-radius:10px;"
        >
          <v-layout row wrap>
            <v-flex xs2>
              <v-avatar size="44" style="z-index:10"><v-img :src="shop.provider.user.imageurl"/></v-avatar>
            </v-flex>
            <v-flex style="padding-top:10px;font-size:120%;text-align:left;font-weight:bold;">
              {{shop.provider.user.displayName}}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- /情報提供者-->
      <!-- system -->
      <v-flex xs12 style="margin-top:16px;margin-bottom:16px;">
        <p v-html="htmlPowerdBy"></p>
      </v-flex>
      <!-- /system -->
      <sns-buttons></sns-buttons>
    </v-container>
      <!-- <div style="position:sticky;z-index:10;bottom:0px;padding:5px 0;background: rgba(255,255,255,1);border-top:solid 1px #ddd;">
        <div style="text-align:center;width:100%;overflow-x: auto;white-space:nowrap;">
          <v-btn
            v-if="isTabetai"
            @click="onDeleteTabetai" round large color="white"
            style="border: solid 2px #F44336 !important;padding:0 10px;color:#F44336"
            >
            <v-icon>favorite</v-icon>
            カライイネ
          </v-btn>
          <v-btn
            v-else
            @click="onTabetai" round large color="white"
            style="border: solid 2px #757575 !important;padding:0 10px;color:#757575"
            >
            <v-icon>favorite_border</v-icon>
            カライイネ
          </v-btn>
          <v-btn
            @click="onReview"
            round large dark color="primary"
            style="border: solid 2px #F44336 !important;padding:0 15px;"
            >
            <v-icon>edit</v-icon>カラログ
          </v-btn>
        </div>
      </div> -->
  </v-card>
</template>

<script>
import SnsCard from '@/components/card/SnsCard.vue'
import SnsButtons from '@/components/common/SnsButtons.vue'
import ReviewCard from '@/components/card/ReviewCard.vue'
import { functions, db } from '@/main'

export default {
  name: 'ShopCard',
  data () {
    return {
      showFoodMaterials: true,
      showFoodDetail: true,
      undefinedText: '---',
      isSnsUrl: false,
      place: {
        formatted_address: '',
        formatted_phone_number: '',
        opening_hours: {
          weekday_text: []
        },
        reviews: [],
        photos: []
      },
      powerdBy: '',
      zakara: '',
      posts: []
    }
  },
  props: {
    shop: Object
  },
  computed: {
    isTabetai () {
      if (this.$store.getters.getTabetaiById(this.shop.id)) {
        return true
      }
      return false
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    imageurl () {
      return this.shop.basic.displayImage
    },
    loginUid () {
      return this.$store.state.user.uid
    },
    isOwner () {
      if (this.loginUid === 'I84vaBSDnMgCVzeOd8X1nrzzzBG3') return true
      return false
    },
    isProvider_gekikara () {
      if (this.shop.provider) {
        if (this.shop.provider.name === 'ザ・激辛日記！！') return true
      }
      return false
    },
    isProvider_karaiine_user () {
      if (this.shop.provider) {
        if (this.shop.provider.name === 'karaiine_user') return true
      }
      return false
    },
    areaText () {
      let a = this.shop.basic.area
      if (a.l !== '') {
        return `${a.l} ＞ ${a.m} ＞ ${a.s}`
      } else {
        return ''
      }
    },
    htmlPowerdBy () {
      if (this.powerdBy === 'ぐるなび') {
        return 'Supported by <a href="https://api.gnavi.co.jp/api/scope/" target="_blank">ぐるなびWebService</a>'
      } else if (this.powerdBy === 'hotpepper') {
        return 'Powered by <a href="http://webservice.recruit.co.jp/">ホットペッパー Webサービス</a>'
      } else if (this.powerdBy === 'Google') {
        return '<img src="/img/powered_by_google_on_white.png"></img>'
      }
      return ''
    },
    address () {
      if (this.powerdBy === 'Google') {
        return this.place.formatted_address
      } else {
        return this.shop.basic.address
      }
    },
    phone () {
      if (this.powerdBy === 'Google') {
        return this.place.formatted_phone_number
      } else {
        return this.shop.basic.tel
      }
    },
    name () {
      if (this.powerdBy === 'Google') {
        return this.place.name
      } else {
        return this.shop.basic.name
      }
    },
    lat () {
      let lat = String(this.shop.basic.lat)
      return lat.slice(0, 4)
    },
    lng () {
      let lng = String(this.shop.basic.lng)
      return lng.slice(0, 5)
    },
    open () {
      if (this.powerdBy === 'Google') {
        return this.place.opening_hours.weekday_text
      } else {
        let list = []
        list.push(this.shop.basic.open)
        return list
      }
    },
    url () {
      if (this.powerdBy === 'Google') {
        return this.place.website
      } else {
        return this.shop.basic.url
      }
    },
    postCount () {
      if (this.shop.postCount) {
        if (this.shop.postCount > 0) {
          return this.shop.postCount
        }
        return 0
      }
      return 0
    },
    tabetaiCount () {
      if (this.shop.tabetaiCount) {
        if (this.shop.tabetaiCount > 0) {
          return this.shop.tabetaiCount
        }
        return 0
      }
      return 0
    },
    snsCount () {
      if (this.shop.snsUrls) {
        return this.shop.snsUrls.length
      }
      return 0
    }
  },
  filters: {
    changeBR (v) {
      if (v) {
        v = v.replace(/\r?\n/g, '<br>')
        return v
      }
      return ''
    },
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    },
    placePhoto (v) {
      return `https://maps.googleapis.com/maps/api/place/photo?maxwidth=600&photoreference=${v}&key=AIzaSyCE1V-P5gOIkFHysmPSa9Ui8WMgbMsb0oQ`
    }
  },
  created () {
    this.powerdBy = this.shop.system.powerdBy
    if (this.powerdBy === '' && this.shop.basic.imageurl === '') {
      this.powerdBy = 'Google'
    }
  },
  mounted () {
    // console.log(this.shop)
    if (this.powerdBy === 'Google') {
      this.getPlace(this.shop.system.ID.placeID)
    }
    this.makeZakara()
    this.getPosts()
  },
  methods: {
    onReview () {
    },
    onTabetai () {
    },
    onResult (r) {
      console.log(r)
    },
    async getPlace (place_id) {
      let api = functions.httpsCallable('apiPlace')
      api({place_id: place_id}).then((result) => {
        this.place = result.data.data.result
        // console.log(this.place)
      })
    },
    makeZakara () {
      let v = this.shop.provider.comment
      if (v) {
        v = v.replace(/\\\\n/g, '<br>')
        v = v.replace(/\r?\n/g, '<br>')
        let reg = new RegExp('https://zakara[\\w/:%#\\$&\\?\\(\\)~\\.=\\+\\-]+')
        let result = v.match(reg)
        if (result) {
          let url = result[0]
          v = v.replace(reg, '')
          v = v.replace('食れぽ！URL', `<a href="${url}" target="_blank">食れぽ！を見てみる</a>`)
        }
        let flag = true
        while (flag) {
          let check = v.slice(-4)
          if (check === '<br>') {
            v = v.slice(0, -4)
          } else {
            flag = false
          }
        }
      }
      this.zakara = v
    },
    async getPosts () {
      let response = await db.collection('post').where('shop.id','==', this.shop.id).orderBy('timestamp', 'desc').get()
      response.forEach((doc) => {
        let p = doc.data()
        p.id = doc.id
        this.posts.push(p)
      })
    },
    onReviewCardClick (post) {
      this.$router.push({name: 'searchReviewDetail', params: {id: post.id}})
    }
  },
  components: {
    SnsButtons,
    SnsCard,
    ReviewCard
  }
}
</script>

<style scoped>
p {
  padding: 0;
  margin: 0;
}
#foodDetail {
  text-align: left;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  max-width:400px;
}
#foodDetail tr td {
  padding: 5px 10px;
}
#foodDetail tr td.foodDetailLabel {
  background-color: #eee;
  font-weight: bold;
}
.VueCarousel-dot--active {
  background-color: #f44336 !important;
}
.komidashi {
  font-weight: bold;
  margin-top:5px;
  margin-bottom:7px;
}
</style>